import React from 'react'
import styled from '@emotion/styled'

import { fontFamilyOpenSans, fontSize2XSmall, grayLight45 } from '../../constants/principles'
import { blueBase, grayBase, redLight10 } from '../../constants/principles'
import { useToggler, useStateValue } from '../../hooks'

export default ({ label, placeholder, value, inputRef, regexPattern, onBlur, onChange, width, height, margin, isError, id, disabled = false, maxLength, type, inputMode }) => {
  const [hasFocus, toggleFocus] = useToggler(false)
  const [localValue, setLocalValue] = useStateValue(value)

  const checkInput = val => {
    return val.match(regexPattern) ? val : localValue
  }

  return (
    <>
      <InputDiv>
        <StyledDiv hasFocus={hasFocus} isError={isError} width={width} height={height} margin={margin}>
          <StyledInput
            type={type || 'text'}
            id={id}
            min="0"
            value={localValue}
            ref={inputRef}
            placeholder={!hasFocus ? placeholder : undefined}
            disabled={disabled}
            onFocus={toggleFocus}
            onBlur={() => {
              toggleFocus()
              onBlur && onBlur(localValue)
            }}
            onChange={e => {
              onChange && onChange(e)
              setLocalValue(checkInput(e.target.value))
            }}
            maxLength={maxLength}
            inputMode={inputMode || ''}
          />
        </StyledDiv>
        <TextLabel>{label}</TextLabel>
      </InputDiv>
    </>
  )
}

const InputDiv = styled.div`
  display: flex;
  -webkit-column-break-inside: avoid;
  -o-column-break-inside: avoid;
  -moz-column-break-inside: avoid;
  break-inside: avoid;
`
const StyledDiv = styled.div`
  font-family: ${fontFamilyOpenSans};
  line-height: 0.1em;
  border: 1px solid;
  border-color: ${p => (p.hasFocus ? blueBase : grayBase)};
  border-color: ${p => p.isError && redLight10};
  text-align: left;
  width: ${p => p.width};
  min-width: ${p => p.width};
  height: ${p => p.height};
  margin: ${p => p.margin};
`
const StyledInput = styled.input`
  color: ${grayBase};
  font-size: ${fontSize2XSmall};
  padding-left: 8px;
  border-style: none;
  &:focus {
    outline: none;
  }
  &::placeholder {
    color: ${grayBase};
  }
  :disabled {
    background-color: ${grayLight45};
  }
  line-height: normal;
  maxlength: ${p => p.maxLength};
  width: 100%;
  height: 100%;
`
const TextLabel = styled.div`
  margin-left: 4px;
  font-size: ${fontSize2XSmall};
  display: flex;
  align-items: center;
`
